export const Accordion = () => {

  $('.accordion__title').on('click', ({ target }) => {
    const $currentElement = $(target);
    const $accordionItem = $currentElement.closest('.accordion__item');

    $accordionItem
      .toggleClass('accordion__item_open')
      .find('.accordion__content')
      .slideToggle(200);

    $accordionItem
      .siblings()
      .removeClass('accordion__item_open')
      .find('.accordion__content')
      .slideUp(200);
  });

};
